export const CSRF_TOKEN_COOKIE_KEY = 'csrftoken';
export const DINER_EMAIL_COOKIE_KEY = 'diner_email';
